import { createFileRoute } from '@tanstack/react-router';
import { getActivitiesOptions } from '../../../../features/claim/activities/queryOptions';
import { ActivitiesTable } from '../../../..//features/claim/activities/table';
import { validateSearch } from '../../../..//utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/claims/$guid/_layout/activities',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getActivitiesOptions(guid, { page })),
  validateSearch: validateSearch,
});

export function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="content-grid">
      <div className="col-span-full">
        <ActivitiesTable activities={data} />
      </div>
    </div>
  );
}
